import React from 'react';
import PropTypes from 'prop-types';
import css from './Checkbox.css';

export default class Checkbox extends React.Component {

    render() {
        const { ariaLabel, onChange, className, ...rest } = this.props;
        return <input type="checkbox"
                      aria-label={ariaLabel}
                      onChange={(event) => onChange(event.target.checked, event.target.value)}
                      className={( className + " " || "" ) + css['sf-checkbox']}
                      {...rest} />
    }
}

Checkbox.propTypes = {
    ariaLabel: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
};
